import React from "react";
import { Link } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import ROUTES_PATH from "../../../constants/routes";
import theme from "../../../constants/Theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardLayout from "../../../layout/DashboardLayout/DashboardLayout";
import EditFAQ from "./EditFAQ";

const styles = {
  centeredContent: {
    [theme.breakpoints.up("xl")]: {
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      width: 1,
    },
  },
};

const FAQEdit = () => {
  return (
    <DashboardLayout>
      <Box
        sx={{
          p: 1,
          pt: { xl: 1, lg: 1, md: 1, sm: 1, xs: 3 },
        }}
      >
        <Grid container>
          <Grid item xl={9} lg={9} md={6} sm={6} xs={12}>
            <Box sx={{ display: "inline-block" }}>
              <Link to={ROUTES_PATH.DASHBOARD + "/faq"}>
                <ArrowBackIcon
                  sx={{
                    fontSize: 30,
                    position: "relative",
                    top: "5px",
                    color: theme => theme.palette.text.primary,
                  }}
                />
              </Link>
            </Box>
            <Typography
              variant="label_xlarge"
              sx={{
                mb: 1,
                ml: 3,
              }}
            >
              Edit FAQ
            </Typography>
          </Grid>

          <Grid item xl={3} lg={3} md={6} sm={6} xs={12} hidden></Grid>
        </Grid>
        <EditFAQ></EditFAQ>
      </Box>
    </DashboardLayout>
  );
};

export default FAQEdit;
